import React, { Component } from 'react';
import '../styles/LoadIndicator.css';


class LoadIndicator extends Component {

    render(){
        return (
            <div class="loading">
                <div class="loading-dot"></div>
                <div class="loading-dot"></div>
                <div class="loading-dot"></div>
                <div class="loading-dot"></div>
            </div>
        );
    }
}

export default LoadIndicator;


// WEBPACK FOOTER //
// ./src/components/LoadIndicator.js